<div class="tree-view text-normal">
    <ul class="pl-4">
        @for(node of treeData; track $index){
            <li class="relative">
                <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node }">
                </ng-container>
            </li>
        }

    </ul>
</div>

<!-- Recursive template for tree nodes -->
<ng-template #treeNodeTemplate let-node>
    <a class="flex items-center py-2" (click)="onNodeClick($event, node)">
        @if(node.children?.length){
            <button
                    (click)="toggle($event, node)"
                    class="w-4 h-4 mr-2 flex items-center justify-center">
                <svg class="transition-all duration-300" [ngClass]="{
                    'rotate-180': node.expanded
                }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 10L12 15L17 10" fill="currentColor"/>
                </svg>

            </button>
        }
        <span class="cursor-pointer hover:text-blue-600" (click)="onNodeClick($event, node)">
        {{node.label}}
      </span>
    </a>

    @if(node.children?.length && node.expanded){
        <ul
                class="pl-6 border-l border-gray-300">
                @for(childNode of node.children; track $index){
                    <li class="relative">
                        <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: childNode }">
                        </ng-container>
                    </li>
                }
                <li class="relative">
                    <a class="flex items-center py-2 cursor-pointer" (click)="newNode($event, node)">+ {{'add' | translate}}</a>
                </li>
        </ul>
    }

</ng-template>